import { useCallback } from 'react';
import Switch from '../../../../../../components/Switch/Switch';

import './PriceSwitch.scss';

type PriceSwitchProps = {
	isMonthly: boolean;
	annualDiscountPercentage: number;
	onSwitch: () => void;
};

const MonthlyOption = () => (
	<h2>Monthly</h2>
);

const PriceSwitch = ( {
	isMonthly = true, annualDiscountPercentage = 20, onSwitch = () => {}
}: PriceSwitchProps ) => {
	const AnnualOption = useCallback( () => (
		<h2 className="SwitchAnnualOption">
			Annually <span className="annualDiscountPercentage"> -{annualDiscountPercentage}%</span>
		</h2>
	), [ annualDiscountPercentage ] );

	return (
		<Switch
			className="PriceSwitch"
			leftOption={{
				Content: AnnualOption as unknown as React.ReactNode,
				isSelected: !isMonthly
			}}
			rightOption={{
				Content: MonthlyOption as unknown as React.ReactNode,
				isSelected: isMonthly
			}}
			onSwitch={onSwitch}
		/>
	);
};

export default PriceSwitch;
